import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { TableTd } from '../../Zemplin/General/Table';
import { ProductPriceCartTable } from './ProductPriceCartTable';
import { getProductDefaultInfo } from '../../../utilities/selectors';
import { StockInfo } from './StockInfo';
import { __ } from 'react-i18n';
import { prop, round } from '../../../utilities';
import { Picture } from '../Picture/Picture';
import { DsiTags as Tags } from '../General/Tags';
import { ProductTabGiftCardLabel } from './ProductTabGiftCardLabel';
import { ProductTabGiftLabel } from './ProductTabGiftLabel';

export interface Props {
  apiUrl: string;
  product: any;
  addToRequest: any;
  addToCart: any;
  // picture: string;
  // price: string;
  // oldPrice: string;
  // availid: number;
  // availability: string;
  // url: string;
  // name: string;
  // isNew: number;
  // isSale: number;
  // isFavorite: boolean;
  // salePercentage: number;
  showSumOfVariants?: boolean;
  hasWatchdog?: boolean;
  hasFavourite?: boolean;
  canOrder?: boolean;
  showMoc?: boolean;
  showWithVat?: boolean;
  loadingPrices?: boolean;
  hasUser?: boolean;
  showStockCount?: boolean;
  isB2b?: boolean;
  isCorporate?: boolean;
  hasGift?: boolean;
  hasCartSale?: boolean;
  conditionTextMapping?: any;
  managerLink?: string;
  showCompareIcon?: boolean;
  isCompare?: boolean;
  addToCompare?: boolean;
}

function ProductTabRowTable({
  apiUrl,
  product,
  addToCart,
  addToRequest,
  showSumOfVariants = false,
  hasFavourite = false,
  hasWatchdog = false,
  canOrder,
  showMoc,
  showWithVat = true,
  loadingPrices,
  hasUser,
  showStockCount,
  isB2b,
  isCorporate,
  hasGift,
  hasCartSale,
  conditionTextMapping,
  managerLink,
  showCompareIcon,
  isCompare,
  addToCompare
}: Props) {
  const {
    availid,
    availability,
    picture,
    url,
    name,
    price,
    oldPrice,
    description,
    currency,
    plu,
    imagePath,
    variants,
    salePercentage,
    onStock,
    isNew,
    isSale,
    isSecondHand,
    isFreeDelivery,
    oldPriceCorporate,
    condition,
    isWaiting,
    hiddenSale,
    forbiddenOrderByDate
  } = getProductDefaultInfo(product, apiUrl, showMoc, showWithVat);
  const variantsText =
    showSumOfVariants && variants && variants.length
      ? `${variants.length} ${
          variants.length === 1
            ? __('variant')
            : variants.length < 5
            ? __('varianty')
            : __('variantov')
        }`
      : '';

  return (
    <>
      <TagsTableTd>
        <StyledTags
            isFreeDelivery={isB2b ? false : isFreeDelivery}
            isNew={isNew}
            isSale={
              isSecondHand
                ? false
                : isCorporate
                ? round(oldPriceCorporate, 2) > round(price, 2)
                : showMoc
                ? round(oldPrice, 2) > round(price, 2)
                : false
            }
            isSecondHand={isSecondHand}
            isVertical={true}
            tagWidth={36}
            tagHeight={36}
            style={{
              position: 'relative',
              top: 0,
              left: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
            hasGift={hasGift}
            hiddenSale={hiddenSale}
          /> 
      </TagsTableTd>
      <ImageNameTableTd>
        <Wrapper>
          <ImageWrapper to={url}>
            <Picture
              alt={`${__('Obrázok ku produktu')} ${name}`}
              image={imagePath}
              width={64}
              height={64}
            />
            {/* <Image alt={`Obrázok ku produktu ${name}`} src={picture} /> */}
          </ImageWrapper>
          <NameWrapper>
            <StyledLink to={url}>
              <Name>{name}</Name>
              {variantsText ? (
                <SumOfVariants>{variantsText}</SumOfVariants>
              ) : null}
            </StyledLink>
            <ProductCode>{plu}</ProductCode>
            {canOrder && (
              <StockInfo
                availability={availability}
                avail_id={availid}
                onStockCount={showStockCount ? onStock : 0}
                isNew={isNew}
                isWaiting={isWaiting}
                conditionTextMapping={conditionTextMapping}
                condition={condition}
              />
            )}
            {managerLink && (
              <a href={`${managerLink}&query=${plu}`} target="_blank">
                Report
              </a>
            )}
            {description ? (
              <Description dangerouslySetInnerHTML={{ __html: description }} />
            ) : null}

            <LabelsWrapper>

            {product?.product_detail?.available_gift_cards?.length ? (
              <ProductTabGiftCardLabel
                price={price}
                currency={currency}
                product={product}
              />
            ) : (
              <></>
            )}
            
            {(hasGift && product?.product_detail?.current_sales?.[0]?.products_sale?.length === 1)?
              <ProductTabGiftLabel product={product.product_detail.current_sales[0].products_sale[0]} />
            :<></>
            }

            </LabelsWrapper>

          </NameWrapper>
        </Wrapper>
      </ImageNameTableTd>
      <ProductPriceCartTable
        price={
          isB2b
            ? showMoc
              ? showWithVat
                ? prop(product, 'moc_price', price)
                : prop(product, 'moc_price_without_vat', price)
              : price
            : price
        }
        oldPrice={
          isSecondHand
            ? '0'
            : isCorporate
            ? oldPriceCorporate
            : isB2b
            ? showWithVat
              ? oldPrice
              : prop(
                  product,
                  'product_detail.main_good.price_without_vat_sale',
                  oldPrice,
                )
            : oldPrice
        }
        isSale={
          isSecondHand
            ? false
            : isCorporate
            ? round(oldPriceCorporate, 2) > round(price, 2)
            : showMoc
            ? round(oldPrice, 2) > round(price, 2)
            : false
        }
        salePercentage={
          isSecondHand
            ? 0
            : isCorporate
            ? 100 - round((price / oldPriceCorporate) * 100, 2)
            : salePercentage
        }
        addToRequest={addToRequest}
        addToCart={addToCart}
        avail_id={availid}
        product={product}
        hasFavourite={hasFavourite}
        hasWatchdog={hasWatchdog}
        currency={currency}
        canOrder={canOrder}
        forbiddenOrder={forbiddenOrderByDate}
        loadingPrices={loadingPrices}
        hasUser={hasUser}
        isNew={isNew}
        isWaiting={isWaiting}
        hiddenSale={hiddenSale}
        showCompareIcon={showCompareIcon}
        isCompare={isCompare}
        addToCompare={addToCompare}
      />
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTags = styled(Tags)`
  padding: ${rem(1)};
  padding-left: 0;
`;

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)};
`;

const TagsTableTd = styled(TableTd)`
  padding-right: 0px;
  display: flex;

  ${({ theme }) => theme.mediab.m580`
    padding: 12px;
  `}
`

const ImageNameTableTd = styled(StyledTableTd)`
  padding-left: 0px;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(24)};

  ${({ theme }) => theme.mediab.m580`
      display: none;
  `}
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
`;

const NameWrapper = styled(FlexCol)`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(180)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(140)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;
  /* display: inline-block; */

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }
`;

const ProductCode = styled(TextP)`
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-size: ${rem(14)};
  font-weight: 400;
`;

const Description = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(440)};
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-size: ${rem(14)};
  font-weight: 400;
`;

const OldDescription = styled(ProductCode)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(440)};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediab.l1050`
      display: block;
  `}
`;

const SumOfVariants = styled.p`
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  font-weight: 400;
  display: inline-block;
  position: relative;
  padding-left: ${rem(8)};
  margin-left: ${rem(8)};
  margin-top: 0;
  margin-bottom: 0;

  &::before {
    content: '';
    display: block;
    width: ${rem(3)};
    height: ${rem(3)};
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.inactiveFontColor};
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  ${({ theme }) => theme.mediab.l1050`
      margin-left: 0;
  `}
`;

const LabelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(10)};
  width: 100%;
  margin-top: ${rem(10)};

`

export { ProductTabRowTable };
